import { container, IESETitle, defaultFont, primaryColor, title} from "assets/jss/material-kit-react.js";

const personalInfoPageStyle = {
  titleheader: {
    background: "#F7F5F3",
    padding: "64px",
    "@media (max-width: 766px)": {
      padding: "40px 16px"
    }
  },
  flexLeftSubmitButton: {
    display: "flex",
    justifyContent: "flex-end"
  },
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
    paddingTop: "20vh",
    color: "#FFFFFF",
    paddingBottom: "200px"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  pageHeader: {
    minHeight: "100vh",
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "0",
    padding: "0",
    border: "0",
    alignItems: "center",
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)"
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""'
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF"
    },
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%"
    }
  },
  form: {
    paddingTop: 0,
    margin: "0",
    marginBottom: "5px",
    // boxShadow: "0 1px 1px rgba(0,0,0,0.10), 0 2px 2px rgba(0,0,0,0.10),    0 2px 2px rgba(0,0,0,0.10),     0 1px 1px rgba(0,0,0,0.10),   0 4px 4px rgba(0,0,0,0.10)"
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px"
  },
  socialIcons: {
    maxWidth: "24px",
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px"
  },
  divider: {
    marginTop: "30px",
    marginBottom: "0px",
    textAlign: "center"
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0"
  },
  inputIconsColor: {
    color: "#495057"
  },
  
  IESETitle: { ...IESETitle},

  regularText: {
    textAlign: "justify",
    color: "#3c4858"
  },

  formControl: {
    margin: "0 0 0px 0",
    paddingTop: "20px",
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: 2,
  },

  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#D2D2D2 !important",
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: primaryColor
    },
    paddingTop: "8px",
  },
  labelRoot: {
    ...defaultFont,
    color: "#AAAAAA !important",
    fontWeight: "400",
    fontSize: "19px",
    maxWidth: "100% !important"  
  },
  
  spacing: {
    marginBottom: "30px"
  },

  checkBox:{
    color: "#504a4a",
    '&$checked': {
      color: "#504a4a",
    },
  },

  defaultFont: {...defaultFont}

};

export default personalInfoPageStyle;
